import { BaseHttpService } from './../../../../../shared/base-http/base-http.service';
import { config } from '../../../../../../config/config';
import { getEnv } from '../../../../../../modules/utility';
import { PageOptions } from 'src/app/shared/data-table/data-table.interface';
import { Injectable } from '@angular/core';

@Injectable()
export class TprCommentApiService {
    constructor(private readonly http: BaseHttpService) { }

    public getTprComments(tprToolId: number, pageOptions?: PageOptions) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/comment?tprToolId=${tprToolId}`
            + `&page=${pageOptions.page}&size=${pageOptions.size}&sort=${pageOptions.sort}&order=${pageOptions.order}`;
        return this.http.get(url);
    }

    public createTprComment(tprToolId: number, body: any) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/comment?tprToolId=${tprToolId}`;
        return this.http.post(url, body);
    }

    public updateTprComment(tprToolId: number, body: any) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/comment?tprToolId=${tprToolId}`;
        return this.http.put(url, body);
    }

    public deleteTprComment(tprToolId: number, id: number) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/comment/${id}?tprToolId=${tprToolId}` ;
        return this.http.delete(url);
    }

}
